import request from "@/utils/request";

export function getCartList(params) {
  return request({ url: "/user/cart/list", method: "get", params: params });
}

// export function getSettleList(params) {
//   return request({
//     url: "/user/cart/settleList",
//     method: "get",
//     params: params
//   });
// }

export function add2Cart(data) {
  return request({ url: "/user/cart/add", method: "post", data: data });
}

export function updateById(data) {
  return request({ url: `/user/cart/updateById`, method: "post", data });
}

export function delCart(cartId) {
  return request({ url: `/user/cart/${cartId}/delete`, method: "post" });
}

export function pay(list) {
  return request({ url: `/user/cart/pay`, method: "post", data: list });
}
